import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileText, Home, Search } from 'lucide-react';

const Navbar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <FileText size={28} />
          <span>Corporate Tally</span>
        </Link>

        <div className="navbar-links">
          <Link
            to="/"
            className={`navbar-link ${isActive('/') ? 'active' : ''}`}
          >
            <Home size={20} />
            <span>Home</span>
          </Link>
          <Link
            to="/add-invoice"
            className={`navbar-link ${isActive('/add-invoice') ? 'active' : ''}`}
          >
            <FileText size={20} />
            <span>Add Invoice</span>
          </Link>
          <Link
            to="/search"
            className={`navbar-link ${isActive('/search') ? 'active' : ''}`}
          >
            <Search size={20} />
            <span>Search</span>
          </Link>
        </div>
      </div>

      <style jsx="true">{`
        .navbar {
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(10px);
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          position: sticky;
          top: 0;
          z-index: 1000;
        }

        .navbar-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 16px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .navbar-logo {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 24px;
          font-weight: 700;
          color: #667eea;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .navbar-logo:hover {
          transform: translateY(-2px);
        }

        .navbar-links {
          display: flex;
          gap: 8px;
        }

        .navbar-link {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          border-radius: 8px;
          color: #64748b;
          text-decoration: none;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .navbar-link:hover {
          background: #f1f5f9;
          color: #667eea;
        }

        .navbar-link.active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }

        @media (max-width: 768px) {
          .navbar-container {
            flex-direction: column;
            gap: 16px;
            padding: 16px;
          }

          .navbar-links {
            width: 100%;
            justify-content: space-around;
          }

          .navbar-link span {
            display: none;
          }

          .navbar-link {
            padding: 10px;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
